export default __webpack_public_path__ + "static/media/425property-gallery3.5ac90745.webp";